import { AlertTriangleIcon } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "@diverge/ui/lib/utils";
import { Button } from "@diverge/ui/ui/button";

export interface ErrorStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  retryLabel?: ReactNode;
  onRetry?: () => void;
  action?: ReactNode;
  className?: string;
}

export function ErrorState({
  icon = <AlertTriangleIcon />,
  title,
  description,
  retryLabel,
  onRetry,
  action,
  className,
}: ErrorStateProps) {
  const retryAction =
    onRetry && retryLabel ? (
      <Button type="button" variant="outline" onClick={onRetry}>
        {retryLabel}
      </Button>
    ) : null;

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-2 rounded-lg border border-destructive/30 bg-destructive/10 px-6 py-12 text-center",
        className,
      )}
    >
      <div className="mb-1 text-destructive [&_svg]:size-8">{icon}</div>
      <p className="text-base font-medium text-foreground">{title}</p>
      {description && <p className="max-w-sm text-sm text-muted-foreground">{description}</p>}
      {(retryAction || action) && <div className="mt-2">{retryAction || action}</div>}
    </div>
  );
}
